export default "__VITE_ASSET__3221e510__$_?component__"